import { Grid } from "@material-ui/core";
import { RenderStatusVerifikasiBadge as StatusTransaksi } from "../../DaftarHelpDesk/helpers";
import { defaultDateDisplay, getLocalName, isNull } from "App/utils/helpers"; // eslint-disable-line
import React, { useContext } from "react";
import { FormContext } from "../context/FormContext";
import { FormDetail, ListDetail } from ".";
import { STATUS_PENGERJAAN_DRAFT } from "../helpers";
export default function RenderListReq({
  classes,
  setNewDataReqList,
  namaInputRef,
}) {
  const { formData, listDetail } = useContext(FormContext);

  return (
    <>
      <div className="mb-1">
        <div
          className="mb-1"
          style={{
            display: "flex",
            gap: "0.5rem",
          }}
        >
          {formData.id !== "" && (
            <>
              <p className="fw-600 mr-1">Status : </p>
              <StatusTransaksi status={formData.status_request} />
            </>
          )}
        </div>
        <ListDetail setNewDataReqList={setNewDataReqList} formData={formData} listDetail={listDetail} />
        {formData.status_request === STATUS_PENGERJAAN_DRAFT && (
          <>
            <Grid
              className="mt-2"
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              ></div>
              <FormDetail setNewDataReqList={setNewDataReqList} />
            </Grid>
          </>
        )}
      </div>
    </>
  );
}
